namespace $.$$ {
	export class $shm_projects_release_notes_view extends $.$shm_projects_release_notes_view {
		override notes(): $shm_projects_release_notes | null { return null }
		scope_text() {
			const notes = this.notes()
			if( !notes ) return ''
			return `${ notes.previous_version ? `После релиза v${ notes.previous_version }` : 'Первый релиз' } · Пререлизов: ${ notes.prerelease_ids.length }`
		}
		content_text() {
			const notes = this.notes()
			if( !notes ) return 'Для этого релиза список изменений ещё не подготовлен.'
			const audience = this.audience()
			return audience === 'technical' ? notes.technical : audience === 'product' ? notes.product
				: audience === 'executive' ? notes.executive : notes.user
		}
	}
}
